import { StatsOverlay as Class } from './StatsOverlay.js';
export const StatsOverlay = Class.getInstance();
